import { difference } from 'lodash'
import mapperQuadrants from './mappers'
import { getNBoxes, getQuadrants } from '@/views/n-box/report/api'

const DEFAULT_STATE = {
    nBoxes: {},
    isLoading: false,
    selectedNBoxes: [],
    slider: {
        isOpen: false,
        user: null,
        quadrant: null,
        nBox: null,
    },
}

const DEFAULT_FILTERS = {
    names: [],
    managers: [],
    committees: [],
    visualization_type: 'calibrated',
}

export default {
    namespaced: true,
    state: {
        ...DEFAULT_STATE,
    },
    getters: {
        hasNBoxes: state => {
            return Object.keys(state.nBoxes).length > 0
        },
    },
    mutations: {
        SET_SLIDER_DATA(state, data) {
            state.slider = data
        },
        SET_SELECTED_N_BOXES(state, value) {
            state.selectedNBoxes = value
        },
        SET_LOADER(state, value) {
            state.isLoading = value
        },
        SET_N_BOXES(state, list) {
            state.nBoxes = list.reduce((object, nBox) => {
                return {
                    ...object,
                    [nBox.id]: {
                        ...nBox,
                        isLoaded: false,
                        isLoading: false,
                        periods: nBox.periods.map(p => p.id),
                        filters: { ...DEFAULT_FILTERS },
                    },
                }
            }, {})
        },
        RESET_SLIDER_STATE(state) {
            state.slider = { ...DEFAULT_STATE.slider }
        },
        RESET_STATE(state) {
            state.selectedNBoxes = []
            state.nBoxes = { ...DEFAULT_STATE.nBoxes }
            state.slider = { ...DEFAULT_STATE.slider }
            state.isLoading = { ...DEFAULT_STATE.isLoading }
        },
        SET_N_BOX_MATRIX(state, { nBoxId, quadrants }) {
            const nBox = state.nBoxes[nBoxId]
            const { users, matrix } = mapperQuadrants(
                quadrants,
                nBox.filters.visualization_type
            )
            state.nBoxes[nBoxId] = {
                ...nBox,
                users,
                matrix,
                quadrants,
            }
        },
        SET_N_BOX_PROPERTY(state, { nBoxId, key, value }) {
            state.nBoxes[nBoxId][key] = value
        },
    },
    actions: {
        resetSliderState(ctx) {
            ctx.commit('RESET_SLIDER_STATE')
        },
        resetData(ctx) {
            ctx.commit('RESET_STATE')
        },
        updateSliderData({ commit }, data) {
            commit('SET_SLIDER_DATA', data)
        },
        updateNBoxLoader({ commit }, { nBoxId, isLoading }) {
            commit('SET_N_BOX_PROPERTY', {
                nBoxId,
                key: 'isLoading',
                value: isLoading,
            })
        },
        updateNBoxFilters(
            ctx,
            { nBoxId, names, managers, committees, visualization_type }
        ) {
            ctx.commit('SET_N_BOX_PROPERTY', {
                nBoxId,
                key: 'filters',
                value: { names, managers, committees, visualization_type },
            })
        },
        setSelectedNBoxes({ commit, state }, value) {
            const removed = difference(state.selectedNBoxes, value)

            removed.forEach(id => {
                commit('SET_N_BOX_PROPERTY', {
                    nBoxId: id,
                    key: 'isLoaded',
                    value: false,
                })

                commit('SET_N_BOX_PROPERTY', {
                    nBoxId: id,
                    key: 'filters',
                    value: { ...DEFAULT_FILTERS },
                })
            })

            commit('SET_SELECTED_N_BOXES', value)
        },
        getNBoxes(ctx) {
            ctx.commit('SET_LOADER', true)
            getNBoxes()
                .then(data => ctx.commit('SET_N_BOXES', data))
                .finally(() => ctx.commit('SET_LOADER', false))
        },
        async getMatrix({ commit, state }, nBoxId) {
            const nBox = state.nBoxes[nBoxId]
            commit('SET_N_BOX_PROPERTY', {
                nBoxId,
                key: 'isLoading',
                value: true,
            })

            const quadrants = await getQuadrants(nBoxId, nBox.filters)

            commit('SET_N_BOX_MATRIX', { nBoxId, quadrants })
            commit('SET_N_BOX_PROPERTY', {
                nBoxId,
                key: 'isLoading',
                value: false,
            })
            commit('SET_N_BOX_PROPERTY', {
                nBoxId,
                key: 'isLoaded',
                value: true,
            })
        },
    },
}
